import { effects } from 'redux-saga'

import { createUser } from '../../../records'

import callWithHmac from '../effects/callWithHmac'

export default function makeUserAutocomplete({
  invocation,
}) {
  return function* userAutocomplete(action) {
    const results = yield effects.call(
      callWithHmac,
      invocation.getUsers,
      action.payload.query,
    )

    // TODO: with the data we get from here we could probably
    // populate the user reducer? Though most of the information
    // being returned here isnt very useful.

    return results.users.map(u => createUser(u))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/autocomplete/user.js